import React from 'react';

const TabsSwitch = ({ options, isActive, onSwitch }) => {
  return (
    <ul className="tabs-nav gap-4 flex !mb-3">
      {options?.map((option, index) => (
        <li key={index} className={isActive === option.value ? 'active' : ''} onClick={() => onSwitch(option.value)}>
          <div className="cursor-pointer">{option.label}</div>
        </li>
      ))}
    </ul>
  );
};

export default TabsSwitch;
